import React, { useState } from 'react';
import { TableInput } from '../../../../components/common';
import handleChangeSpec from '../../helpers/handleChangeSpec';

interface IProps {
  spec: any;
  isView: boolean;
  checkType: string;
  obsIndex: number;
  obsNumber: number;
  setRender: any;
}
const ObservationInput = ({
  spec,
  isView,
  checkType,
  obsIndex,
  obsNumber,
  setRender,
}: IProps) => {
  if (checkType === 'check3') {
    return (
      <>
        <td style={{ textTransform: 'uppercase', minWidth: '120px' }}>
          {isView ? (
            spec[`check_${obsNumber}_values`][obsIndex] || ''
          ) : (
            <TableInput
              name="observation"
              type="text"
              value={spec[`check_${obsNumber}_values`][obsIndex] || ''}
              onChange={(e) => {
                handleChangeSpec(e, spec, obsIndex, obsNumber);
                setRender((prev: any) => !prev);
              }}
              style={{
                textAlign: 'center',
              }}
              isView={isView}
            />
          )}
        </td>
      </>
    );
  }
  if (
    checkType === 'check1' ||
    checkType === 'check2' ||
    checkType === 'check4'
  ) {
    return (
      <>
        <td style={{ minWidth: '120px' }}>
          <TableInput
            name="observation"
            type="number"
            value={spec[`check_${obsNumber}_values`][obsIndex] || ''}
            onChange={(e) => {
              handleChangeSpec(e, spec, obsIndex, obsNumber);
              setRender((prev: any) => !prev);
            }}
            style={{
              backgroundColor: spec[`check_${obsNumber}_colors`][obsIndex],
              textAlign: 'center',
            }}
            isView={isView}
          />
        </td>
      </>
    );
  }
  return (
    <React.Fragment>
      <td style={{ minWidth: '120px' }}></td>
    </React.Fragment>
  );
};
export default ObservationInput;
